import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-12 col-lg-12 col-xxxl-12 col-sm-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_4 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "title ms-15" }
const _hoisted_7 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium" }
const _hoisted_8 = { class: "fw-black mb-8 lh-1" }
const _hoisted_9 = {
  key: 0,
  class: "fw-medium"
}

import { popScopeId } from "vue";

import statsBoxes from "./statsBoxes.json";

interface Iprops {
  class: string,
  icon: string,
  title: string,
  sign: string,
  currentValue: string,
  previousValue: string,
  classTwo: string,
  percent: number,
  iconUpDown: string,
  viewPrevius?: boolean,
  viewPercent?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    class: {},
    icon: {},
    title: {},
    sign: {},
    currentValue: {},
    previousValue: {},
    classTwo: {},
    percent: {},
    iconUpDown: {},
    viewPrevius: { type: Boolean },
    viewPercent: { type: Boolean }
  },
  setup(__props: any) {


var props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass([
                'icon position-relative rounded-circle text-center',
                _unref(props).class,
              ])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(props).icon)
              }, null, 2)
            ], 2),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(props).title), 1),
              _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(props).sign) + _toDisplayString(_unref(props).currentValue), 1),
              (_unref(props).viewPrevius)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(props).sign) + _toDisplayString(_unref(props).previousValue), 1))
                : _createCommentVNode("", true),
              (_unref(props).viewPercent)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(['fw-bold text-success ms-11', _unref(props).classTwo])
                  }, [
                    _createTextVNode(_toDisplayString(_unref(props).percent.toFixed(2)) + "% ", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass([
                    _unref(props).iconUpDown,
                    'fs-12 lh-1 position-relative top-1',
                  ])
                    }, null, 2)
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})